var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98484 10.1528L6.32454 13.8131",
    stroke: "#FDFAFF",
    strokeWidth: 1.80015,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36028 10.189L10.0206 13.8493",
    stroke: "#FDFAFF",
    strokeWidth: 1.80015,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7369 12.001H14.7489",
    stroke: "#FDFAFF",
    strokeWidth: 2.4002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4658 12.001H19.4778",
    stroke: "#FDFAFF",
    strokeWidth: 2.4002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1014 14.377V14.353",
    stroke: "#FDFAFF",
    strokeWidth: 2.4002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1014 9.649V9.625",
    stroke: "#FDFAFF",
    strokeWidth: 2.4002,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30076 21.602H16.5013C22.5018 21.602 24.902 19.2018 24.902 13.2013V10.8011C24.902 4.80059 22.5018 2.40039 16.5013 2.40039H9.30076C3.30027 2.40039 0.900074 4.80059 0.900074 10.8011V13.2013C0.900074 19.2018 3.30027 21.602 9.30076 21.602Z",
    stroke: "#FDFAFF",
    strokeWidth: 1.80015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.fb1428fa4b010b1f311e206d8d4f6c60.svg";
export { ForwardRef as ReactComponent };